var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lite-youtube',{attrs:{"videoid":_vm.videoid,"playlabel":_vm.playlabel,"params":"controls=0&start=10&end=30&modestbranding=2&rel=0&enablejsapi=1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }